module.exports = __webpack_public_path__ + "img/center_logo.3d74e260.png";